export const AllOW_PARENT_ORIGINS = [
  'http://localhost:4200',
  'http://localhost:4201',
  'http://localhost:4202',
  'http://localhost:4203',
  'http://localhost:5200',
  'https://bi.beaconconnect.app',
  'https://bi.dev.beaconconnect.app',
  'https://bi.stage.beaconconnect.app',
  'https://admin.beaconconnect.app',
  'https://admin.dev.beaconconnect.app',
  'https://admin.stage.beaconconnect.app',
];
